import { View } from "./Consultations.view";

export const Container = () => {
  return <View />;
};
